// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2SqDE","name":"ConsentHeader_name__2242R","birthday":"ConsentHeader_birthday__1F8YY","skeleton":"ConsentHeader_skeleton__2s4U5"};